const textLabels = {
  body: {
    noMatch: "Désolé, aucun enregistrement correspondant n'a été trouvé",
    toolTip: "Trier",
  },
  pagination: {
    next: "Page suivante",
    previous: "Page précédente",
    rowsPerPage: "Ligne par page:",
    displayRows: "de",
    jumpToPage: "Aller à la page:",
  },
  toolbar: {
    search: "Rechercher",
    downloadCsv: "Télécharger CSV",
    viewColumns: "Afficher les colonnes",
    filterTable: "Tableau des filtres",
  },
  viewColumns: {
    title: "Afficher les colonnes",
    titleAria: "Afficher/Masquer les colonnes du tableau",
  },
  selectedRows: {
    text: "ligne(s) sélectionnée(s)",
    delete: "Effacer",
    deleteAria: "Supprimer les lignes sélectionnées",
  },
};
export default textLabels;
